// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QLxGT","select":"styles_select__t2Z7e","selectCustom":"styles_selectCustom__qPSro","selectError":"styles_selectError__+d524"};